import { render, staticRenderFns } from "./HeadBar.vue?vue&type=template&id=be156bee&scoped=true&"
import script from "./HeadBar.vue?vue&type=script&lang=js&"
export * from "./HeadBar.vue?vue&type=script&lang=js&"
import style0 from "./HeadBar.vue?vue&type=style&index=0&id=be156bee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be156bee",
  null
  
)

export default component.exports